/**
 * Application Status Utilities
 *
 * Constants and helpers for managing application statuses.
 * Applications start as 'pending' and can be moved to
 * 'offered', 'confirmed', or 'rejected' by admins.
 */

export const APPLICATION_STATUSES = {
  PENDING: 'pending',
  OFFERED: 'offered',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
};

export const SLOT_TYPES = {
  PERFORMER: 'performer',
  MC: 'mc',
  ADMIN_TECH: 'admin_tech',
};

export const SLOT_TYPE_LABELS = {
  performer: 'Performer',
  mc: 'MC',
  admin_tech: 'Admin/Tech',
};

const STATUS_LABELS = {
  pending: 'Pending',
  offered: 'Offered',
  confirmed: 'Confirmed',
  rejected: 'Rejected',
};

const STATUS_COLORS = {
  pending: '#6c757d',
  offered: '#fd7e14',
  confirmed: '#28a745',
  rejected: '#dc3545',
};

/**
 * Get a human-readable label for a status value.
 *
 * @param {string|null|undefined} status
 * @returns {string}
 */
export function getStatusLabel(status) {
  if (!status) return STATUS_LABELS.pending;
  return STATUS_LABELS[status] || status;
}

/**
 * Get the display color for a status value.
 *
 * @param {string|null|undefined} status
 * @returns {string}
 */
export function getStatusColor(status) {
  if (!status) return STATUS_COLORS.pending;
  return STATUS_COLORS[status] || STATUS_COLORS.pending;
}

/**
 * Get a human-readable label for a slot type value.
 *
 * @param {string|null|undefined} slotType
 * @returns {string}
 */
export function getSlotTypeLabel(slotType) {
  if (!slotType) return SLOT_TYPE_LABELS.performer;
  return SLOT_TYPE_LABELS[slotType] || slotType;
}
